var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [_vm._m(0), _vm._v(" "), _c("app-backend-footer")],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container-fluid xyz" }, [
      _c("div", { staticClass: "page-header-top-container" }, [
        _c("div", { staticClass: "page-name" }, [_vm._v("Chat App")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "admin-page-content" }, [
        _c("section", { staticClass: "nc-chat-container" }, [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "nc-chat-block" }, [
              _c("div", { staticClass: "nc-chat-left-container" }, [
                _c("div", { staticClass: "nc-chat-left-mobile" }, [
                  _c("div", { staticClass: "nc-chat-right-container-top" }, [
                    _c("a", { staticClass: "nc-back", attrs: { href: "#" } }, [
                      _c("i", {
                        staticClass: "fa fa-angle-left",
                        attrs: { "aria-hidden": "true" }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "nc-chat-activer-user" }, [
                      _c("span", [_vm._v("Users List")])
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      { attrs: { type: "submit", onclick: "myFunction()" } },
                      [
                        _c("span", {
                          staticClass:
                            "glyphicon glyphicon-search custom-search"
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: { display: "none" },
                        attrs: { id: "myDIV" }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "input-group stylish-input-group" },
                          [
                            _c("input", {
                              staticClass: "form-control",
                              attrs: { type: "text", placeholder: "Search" }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "input-group-addon" }, [
                              _c("button", { attrs: { type: "submit" } }, [
                                _c("span", {
                                  staticClass: "glyphicon glyphicon-search"
                                })
                              ])
                            ])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "nc-chat-link",
                        staticStyle: { display: "none" }
                      },
                      [
                        _c("a", { attrs: { href: "#" } }, [
                          _c("i", {
                            staticClass: "fa fa-sign-out",
                            attrs: { "aria-hidden": "true" }
                          }),
                          _c("br"),
                          _vm._v(" "),
                          _c("span", [_vm._v("End Chat")])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "nc-chat-right-dropdown" }, [
                      _c("div", { staticClass: "dropdown" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary dropdown-toggle",
                            attrs: { type: "button", "data-toggle": "dropdown" }
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-ellipsis-v",
                              attrs: { "aria-hidden": "true" }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("ul", { staticClass: "dropdown-menu" }, [
                          _c("li", [
                            _c("a", { attrs: { href: "#" } }, [_vm._v("HTML")])
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("a", { attrs: { href: "#" } }, [_vm._v("CSS")])
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("a", { attrs: { href: "#" } }, [
                              _vm._v("JavaScript")
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "nc-chat-type" }, [
                  _c("a", { attrs: { href: "#" } }, [
                    _vm._v("Customers "),
                    _c("sup", [_vm._v("1")])
                  ]),
                  _vm._v(" "),
                  _c("a", { staticClass: "active", attrs: { href: "#" } }, [
                    _vm._v("Users")
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "nc-search" }, [
                  _c(
                    "div",
                    { staticClass: "input-group stylish-input-group" },
                    [
                      _c("input", {
                        staticClass: "form-control",
                        attrs: { type: "text", placeholder: "Search" }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "input-group-addon" }, [
                        _c("button", { attrs: { type: "submit" } }, [
                          _c("span", {
                            staticClass: "glyphicon glyphicon-search"
                          })
                        ])
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "ul",
                  {
                    staticClass: "nc-listing-container mCustomScrollbar",
                    attrs: { "data-mcs-theme": "minimal" }
                  },
                  [
                    _c("li", { staticClass: "nc-listing-block" }, [
                      _c("div", { staticClass: "nc-user-avtar" }, [
                        _c("img", {
                          attrs: { src: "/static/images/default-img.png" }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "nc-user-info" }, [
                        _c("div", { staticClass: "nc-user-info-top" }, [
                          _c("div", { staticClass: "nc-user-name" }, [
                            _vm._v("Admin")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "nc-chat-time" }, [
                            _vm._v("5:42 PM")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "nc-user-description" }, [
                          _vm._v(
                            "\n                                            Lorem ipsum dolor sit amet, consectetuer\n                                        "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "nc-new-chat-noti" }, [
                          _vm._v("1")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "nc-listing-block" }, [
                      _c("div", { staticClass: "nc-user-avtar" }, [
                        _c("img", {
                          attrs: { src: "/static/images/default-img.png" }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "nc-user-info" }, [
                        _c("div", { staticClass: "nc-user-info-top" }, [
                          _c("div", { staticClass: "nc-user-name" }, [
                            _vm._v("James Smith (FAS)")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "nc-chat-time" }, [
                            _vm._v("5:42 PM")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "nc-user-description" }, [
                          _vm._v(
                            "\n                                            Lorem ipsum dolor sit amet, consectetuer\n                                        "
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "nc-listing-block" }, [
                      _c("div", { staticClass: "nc-user-avtar" }, [
                        _c("img", {
                          attrs: { src: "/static/images/default-img.png" }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "nc-user-info" }, [
                        _c("div", { staticClass: "nc-user-info-top" }, [
                          _c("div", { staticClass: "nc-user-name" }, [
                            _vm._v("David (FAS)")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "nc-chat-time" }, [
                            _vm._v("5:42 PM")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "nc-user-description" }, [
                          _vm._v(
                            "\n                                            Lorem ipsum dolor sit amet, consectetuer\n                                        "
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "nc-listing-block" }, [
                      _c("div", { staticClass: "nc-user-avtar" }, [
                        _c("img", {
                          attrs: { src: "/static/images/default-img.png" }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "nc-user-info" }, [
                        _c("div", { staticClass: "nc-user-info-top" }, [
                          _c("div", { staticClass: "nc-user-name" }, [
                            _vm._v("Maria Garcia (Velocity Rental)")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "nc-chat-time" }, [
                            _vm._v("5:42 PM")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "nc-user-description" }, [
                          _vm._v(
                            "\n                                            Lorem ipsum dolor sit amet, consectetuer\n                                        "
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "nc-listing-block" }, [
                      _c("div", { staticClass: "nc-user-avtar" }, [
                        _c("img", {
                          attrs: { src: "/static/images/default-img.png" }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "nc-user-info" }, [
                        _c("div", { staticClass: "nc-user-info-top" }, [
                          _c("div", { staticClass: "nc-user-name" }, [
                            _vm._v("Robert Smith (Velocity Rental) ")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "nc-chat-time" }, [
                            _vm._v("5:42 PM")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "nc-user-description" }, [
                          _vm._v(
                            "\n                                            Lorem ipsum dolor sit amet, consectetuer\n                                        "
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "nc-listing-block" }, [
                      _c("div", { staticClass: "nc-user-avtar" }, [
                        _c("img", {
                          attrs: { src: "/static/images/default-img.png" }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "nc-user-info" }, [
                        _c("div", { staticClass: "nc-user-info-top" }, [
                          _c("div", { staticClass: "nc-user-name" }, [
                            _vm._v("Smith (Velocity Rental) ")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "nc-chat-time" }, [
                            _vm._v("5:42 PM")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "nc-user-description" }, [
                          _vm._v(
                            "\n                                            Lorem ipsum dolor sit amet, consectetuer\n                                        "
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "nc-listing-block" }, [
                      _c("div", { staticClass: "nc-user-avtar" }, [
                        _c("img", {
                          attrs: { src: "/static/images/default-img.png" }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "nc-user-info" }, [
                        _c("div", { staticClass: "nc-user-info-top" }, [
                          _c("div", { staticClass: "nc-user-name" }, [
                            _vm._v("Admin")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "nc-chat-time" }, [
                            _vm._v("5:42 PM")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "nc-user-description" }, [
                          _vm._v(
                            "\n                                            Lorem ipsum dolor sit amet, consectetuer\n                                        "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "nc-new-chat-noti" }, [
                          _vm._v("1")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "nc-listing-block" }, [
                      _c("div", { staticClass: "nc-user-avtar" }, [
                        _c("img", {
                          attrs: { src: "/static/images/default-img.png" }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "nc-user-info" }, [
                        _c("div", { staticClass: "nc-user-info-top" }, [
                          _c("div", { staticClass: "nc-user-name" }, [
                            _vm._v("James Smith (FAS)")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "nc-chat-time" }, [
                            _vm._v("5:42 PM")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "nc-user-description" }, [
                          _vm._v(
                            "\n                                            Lorem ipsum dolor sit amet, consectetuer\n                                        "
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "nc-listing-block" }, [
                      _c("div", { staticClass: "nc-user-avtar" }, [
                        _c("img", {
                          attrs: { src: "/static/images/default-img.png" }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "nc-user-info" }, [
                        _c("div", { staticClass: "nc-user-info-top" }, [
                          _c("div", { staticClass: "nc-user-name" }, [
                            _vm._v("David (FAS)")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "nc-chat-time" }, [
                            _vm._v("5:42 PM")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "nc-user-description" }, [
                          _vm._v(
                            "\n                                            Lorem ipsum dolor sit amet, consectetuer\n                                        "
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "nc-listing-block" }, [
                      _c("div", { staticClass: "nc-user-avtar" }, [
                        _c("img", {
                          attrs: { src: "/static/images/default-img.png" }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "nc-user-info" }, [
                        _c("div", { staticClass: "nc-user-info-top" }, [
                          _c("div", { staticClass: "nc-user-name" }, [
                            _vm._v("Maria Garcia (Velocity Rental)")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "nc-chat-time" }, [
                            _vm._v("5:42 PM")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "nc-user-description" }, [
                          _vm._v(
                            "\n                                            Lorem ipsum dolor sit amet, consectetuer\n                                        "
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "nc-listing-block" }, [
                      _c("div", { staticClass: "nc-user-avtar" }, [
                        _c("img", {
                          attrs: { src: "/static/images/default-img.png" }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "nc-user-info" }, [
                        _c("div", { staticClass: "nc-user-info-top" }, [
                          _c("div", { staticClass: "nc-user-name" }, [
                            _vm._v("Robert Smith (Velocity Rental) ")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "nc-chat-time" }, [
                            _vm._v("5:42 PM")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "nc-user-description" }, [
                          _vm._v(
                            "\n                                            Lorem ipsum dolor sit amet, consectetuer\n                                        "
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "nc-listing-block" }, [
                      _c("div", { staticClass: "nc-user-avtar" }, [
                        _c("img", {
                          attrs: { src: "/static/images/default-img.png" }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "nc-user-info" }, [
                        _c("div", { staticClass: "nc-user-info-top" }, [
                          _c("div", { staticClass: "nc-user-name" }, [
                            _vm._v("Smith (Velocity Rental) ")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "nc-chat-time" }, [
                            _vm._v("5:42 PM")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "nc-user-description" }, [
                          _vm._v(
                            "\n                                            Lorem ipsum dolor sit amet, consectetuer\n                                        "
                          )
                        ])
                      ])
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "nc-chat-right-container" }, [
                _c("div", { staticClass: "nc-chat-right-container-top" }, [
                  _c("a", { staticClass: "nc-back", attrs: { href: "#" } }, [
                    _c("i", {
                      staticClass: "fa fa-angle-left",
                      attrs: { "aria-hidden": "true" }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "nc-chat-activer-user" }, [
                    _c("img", { attrs: { src: "/static/images/img.jpg" } }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Guest 1")])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "nc-chat-link" }, [
                    _c("a", { attrs: { href: "#" } }, [
                      _c("span", { staticClass: "icon-End-chat" }),
                      _c("br"),
                      _vm._v(" "),
                      _c("span", [_vm._v("End Chat")])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "nc-chat-link" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "#",
                          "data-toggle": "modal",
                          "data-target": "#myModal"
                        }
                      },
                      [
                        _c("span", { staticClass: "icon-Forward" }),
                        _c("br"),
                        _vm._v(" "),
                        _c("span", [_vm._v("Forward")])
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "nc-user-chat-area mCustomScrollbar",
                    attrs: { "data-mcs-theme": "minimal" }
                  },
                  [
                    _c("div", { staticClass: "nc-user-chat" }, [
                      _c("img", { attrs: { src: "/static/images/img.jpg" } }),
                      _vm._v(" "),
                      _c("div", { staticClass: "nc-user-chat-content" }, [
                        _c("p", [_vm._v("Hi, Good Morning!!")]),
                        _vm._v(" "),
                        _c("span", [_vm._v("10:45 PM")])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "nc-admin-chat" }, [
                      _c("div", { staticClass: "nc-admin-chat-content" }, [
                        _c("span", [_vm._v("10:45 PM")]),
                        _vm._v(" "),
                        _c("p", [_vm._v("Hi, Good Morning!!")])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "nc-user-chat" }, [
                      _c("img", { attrs: { src: "/static/images/img.jpg" } }),
                      _vm._v(" "),
                      _c("div", { staticClass: "nc-user-chat-content" }, [
                        _c("p", [
                          _vm._v(
                            "Lorem ipsum dolor sit amet,\n                                            consectetuer adipiscing elit\n                                        "
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", [_vm._v("10:45 PM")])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "nc-admin-chat" }, [
                      _c("div", { staticClass: "nc-admin-chat-content" }, [
                        _c("span", [_vm._v("10:45 PM")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Lorem ipsum dolor sit amet, consectetuer \n                                            adipiscing elit, sed diam nonummy nibh euismod\n                                            tincidunt ut laoreet dolore magna aliquam.\n                                        "
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "nc-user-chat" }, [
                      _c("img", { attrs: { src: "/static/images/img.jpg" } }),
                      _vm._v(" "),
                      _c("div", { staticClass: "nc-user-chat-content" }, [
                        _c("p", [_vm._v("Hi, Good Morning!!")]),
                        _vm._v(" "),
                        _c("span", [_vm._v("10:45 PM")])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "nc-admin-chat" }, [
                      _c("div", { staticClass: "nc-admin-chat-content" }, [
                        _c("span", [_vm._v("10:45 PM")]),
                        _vm._v(" "),
                        _c("p", [_vm._v("Hi, Good Morning!!")])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "nc-user-chat" }, [
                      _c("img", { attrs: { src: "/static/images/img.jpg" } }),
                      _vm._v(" "),
                      _c("div", { staticClass: "nc-user-chat-content" }, [
                        _c("p", [
                          _vm._v(
                            "Lorem ipsum dolor sit amet,\n                                            consectetuer adipiscing elit\n                                        "
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", [_vm._v("10:45 PM")])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "nc-admin-chat" }, [
                      _c("div", { staticClass: "nc-admin-chat-content" }, [
                        _c("span", [_vm._v("10:45 PM")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Lorem ipsum dolor sit amet, consectetuer \n                                            adipiscing elit, sed diam nonummy nibh euismod\n                                            tincidunt ut laoreet dolore magna aliquam.\n                                        "
                          )
                        ])
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "nc-comment-area" }, [
                  _c("textarea", {
                    attrs: { placeholder: "Type your message here..." }
                  }),
                  _vm._v(" "),
                  _c("a", { attrs: { href: "#" } }, [
                    _c("img", {
                      attrs: { src: "/static/images/textarea-button.png" }
                    })
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66b8ec3c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66b8ec3c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat-app.vue
// module id = null
// module chunks = 